"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.getCurrentUser = exports.isPreview = exports.isLoggedIn = exports.getUser = exports.setUser = void 0;

var _getStorageKey = _interopRequireDefault(require("./getStorageKey"));

var _getParameter = _interopRequireDefault(require("./getParameter"));

var storageKey = (0, _getStorageKey.default)();
var isBrowser = typeof window !== "undefined";

var setUser = function setUser(user) {
  if (storageKey) {
    window.localStorage[storageKey] = JSON.stringify(user);
  }
};

exports.setUser = setUser;

var getUser = function getUser() {
  if (storageKey && window.localStorage[storageKey]) {
    var user = JSON.parse(window.localStorage[storageKey]);
    return user ? user : {};
  }

  return {};
};

exports.getUser = getUser;

var isLoggedIn = function isLoggedIn() {
  if (!isBrowser) {
    return false;
  }

  var user = getUser();

  if (user) {
    return !!user.authToken;
  }

  return false;
};

exports.isLoggedIn = isLoggedIn;

var isPreview = function isPreview() {
  if (!isBrowser) {
    return false;
  }

  var preview = (0, _getParameter.default)('preview');

  if (!preview) {
    return false;
  }

  return preview;
};

exports.isPreview = isPreview;

var getCurrentUser = function getCurrentUser() {
  return isBrowser && getUser();
};

exports.getCurrentUser = getCurrentUser;

var logout = function logout(callback) {
  if (!isBrowser) {
    return;
  }

  setUser({});
  callback();
};

exports.logout = logout;